import React from 'react'

import NeatVsCompetitorCompare from '@/components/templates/NeatVsCompetitorCompare'
import trendsInsightsImg from '@/assets/track-receipts/trends-insights.png'
import allFilesImg from '@/assets/features-potential/all-files.jpg'
import shoeboxedLogo from '@/assets/neat-competitor/shoeboxed-logo.jpg'
import avatarImage from '@/assets/testimonials/avatar.png'

const pageId = 'neatVsShoeboxed'

const overview = [
  {
    title: 'Track receipts and other documents through these apps',
    text:
  <><p>Neat and Shoeboxed allow you to track your receipts. Both software applications provide various ways to upload your documents easily and have powerful data extraction & verification technologies. Shoeboxed can scan receipts and business cards. Neat allows scanning receipts and business cards as well as other documents such as bills, invoices, bank statements, checks, and more.</p>
    <p>Shoeboxed allows unlimited storage and a number of scans per month or year depending on the plan you subscribe to. Their startup plan allows 600 digital scans per year while their most expensive plan allows 3600 digital scans per year. Also, Shoeboxed has a facility to mail physical receipts to and each plan has a set amount of physical documents you can have scanned.</p>
    <p>Neat provides unlimited scans/parsing and storage of documents with any plan.</p>
  </>,
  },
  {
    title: 'Expense & financial reporting',
    text:
  <><p>Neat provides expense reporting as well as additional spending and tax focused reports. The Automated Insights upgrade allows you to connect directly to financial institutions to power expanded reports and insights such as net cash flow, cash balance, and profit & loss, all without requiring users to scan or manually enter each expense. Scanned receipts and other documents can easily be paired with your transactions through guided workflows to make accounting and audit preparedness easy.</p>
    <p>Shoeboxed provides expense reporting only.</p>
  </>,
  },
  {
    title: 'Pricing',
    text:
  <><p>Neat and Shoeboxed both have comparable pricing plans that fit your need for a receipt tracking app.</p>
    <p>Shoeboxed offers 3 plans tailored to levels of scans. For most individuals and freelancers their Startup plan allows 600 digital and 300 physical scans a year at $216 a year. Their Professional plan is suited for small businesses allowing 1,800 digital and 1,800 physical scans a year at $432 a year. Business plan for high volume allows 3,600 digital and 3,600 physical scans a year at $648 a year. The Startup plan does not include Quickbooks integration.</p>
    <p>Neat offers a base plan to handle unlimited receipt scans at $200 a year. The base plan can also be enhanced with add-ons. Neat offers their VIP service to provide premium help that includes 1:1 training guided by Neat experts, a dedicated support team, and early access to new features and exclusive offers at $250 a year. Neat’s Automated Insights plan provides insights into your finances with real-time accounting and expense reporting at $350 a year. You can also get Neat’s base plan and both VIP and Automated Insights for $400 a year. Integrations like Quickbooks are already a part of the Neat Base plan.</p>
  </>,
  },
]

const comparisons = [
  {
    rowTitle: 'Overview',
    neatText: 'Neat helps you scan and track receipts and documents. Neat’s powerful OCR technology extracts key information for automation. You can also monitor top expense categories, cash balances, and analyze finances with live data. Neat is a smart file organization and financial reporting tool.',
    competitorText: 'Shoeboxed digitizes and organizes receipts for small businesses. Users can scan receipts via app or mail them in.',
  },
  {
    rowTitle: 'Platforms supported',
    neatText: 'Neat can be accessed anywhere, anytime as a web-based app, iOS & Android.',
    competitorText: 'Web-based, iOS & Android.',
  },
  {
    rowTitle: 'Best for',
    neatList: [
      'Accountants/Bookkeepers',
      'Small to Medium size businesses',
      'Freelancers',
    ],
    competitorList: [
      'Accountants/Bookkeepers',
      'Small to Medium size businesses',
      'Freelancers',
    ],
  },
  {
    rowTitle: 'Customer support',
    neatList: [
      'Chat',
      'Email',
      'Phone',
      '24/7 Knowledge Base',
      'Webinars',
    ],
    competitorList: [
      'Phone',
      'Online',
      'Video Tutorials',
    ],
  },
  {
    rowTitle: 'Features',
    neatList: [
      'Document scanning by mobile, email, drag & drop to app, or compatible scanner',
      'Unlimited file storage',
      'Organize files by expense type, tax category, and more',
      'Easily filter and search for documents',
      'Track expenses with reporting and insights capabilities built-in',
      'Real-time insights - including net cash flow, top expense categories, cash balance, profit and loss',
      'Connect to bank accounts',
      'Categorization of expenses can be done without requiring a file to be captured',
      'Bank-level data security',
    ],
    competitorList: [
      'Receipt scanning by mobile, Gmail and any HP web-connected printer',
      'Mail receipts to facility',
      'Unlimited file storage',
      '15 automatic tax cateogries',
      'Receipt search',
      'Comprehensive expense reports',
    ],
  },
  {
    rowTitle: 'Integrations',
    neatList: [
      'Intuit Quickbooks',
      'Intuit Turbotax',
      'H&R Block',
      'Quicken',
      'Outlook',
      'Campaign Monitor',
      'Mailchimp',
      'Google Contacts',
      'Constant Contact',
    ],
    competitorList: [
      'Intuit Quickbooks',
      'Xero',
      'Evernote',
      'WorkingPoint',
      'Bench',
      'Wave',
      'Getmyinvoices.com',
      'Sky Clerk',
      'and more',
    ],
  },
  {
    rowTitle: 'Pricing',
    neatList: [
      'Neat - $200/yr',
      'Neat w/ VIP Service - $250/yr',
      'Neat w/ Automated Insights (AI) - $350/yr',
      'Neat w/ AI & VIP - $400/yr',
      'Free trial available',
    ],
    competitorList: [
      'Startup - $216/yr',
      'Professional - $432/yr',
      'Business - $648/yr',
      'Free trial available ',
    ],
  },
]

const featureComparison = [
  {
    feature: 'Receipt Scanning',
    neat: true,
    competitor: true,
  },
  {
    feature: 'Unlimited Storage',
    neat: true,
    competitor: true,
  },
  {
    feature: 'iOS & Android app',
    neat: true,
    competitor: true,
  },
  {
    feature: 'Expense Report',
    neat: true,
    competitor: true,
  },
  {
    feature: 'Unlimited Parsing',
    neat: true,
    competitor: false,
  },
  {
    feature: 'Reconciliation',
    neat: true,
    competitor: false,
  },
  {
    feature: 'Connect Bank Accounts',
    neat: true,
    competitor: false,
  },
  {
    feature: 'Real-time insights',
    neat: true,
    competitor: false,
  },
  {
    feature: 'Accounting reports',
    neat: true,
    competitor: false,
  },
]

const testimonialSliderProps = {
  author: 'Joann D.',
  text: 'I have been using Neat for at least 7 years, and it\'s made tracking receipts and generating year end reports a breeze.',
  avatar: avatarImage,
  slides: [
    { image: trendsInsightsImg },
    { image: allFilesImg },
  ],
}

export default function NeatVsShoeboxed() {
  return (
    <NeatVsCompetitorCompare
      comparisons={comparisons}
      competitorLogo={shoeboxedLogo}
      competitorName="Shoeboxed"
      ctaTitle="Easy and efficient - now that's Neat!"
      featureComparison={featureComparison}
      heroTitle={<>Simplify the way you track & manage receipt scanning with a reliable app</>}
      overview={overview}
      pageTitle="Neat vs. Shoeboxed"
      testimonialSliderProps={testimonialSliderProps}
    />
  )
}

NeatVsShoeboxed.layoutProps = {
  pageId,
  showFooter: false,
  showHeader: false,
}
